import type { RouteRecordRaw } from 'vue-router'
import {
  productManagementRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createProductChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: 'overview',
    ...maybeRouteName(withNames, 'product-mgmt-overview'),
    component: () => import('@/views/product/Productlist.vue'),
    meta: { title: '产品资产总览', permission: 'product:overview:view' }
  },
  {
    path: 'work-pool',
    ...maybeRouteName(withNames, 'product-mgmt-work-pool'),
    component: () => import('@/views/product/WorkPool.vue'),
    meta: { title: '岗位梳理 / 工作池', permission: 'product:work_pool:view' }
  },
  {
    path: 'selection',
    ...maybeRouteName(withNames, 'product-mgmt-selection'),
    component: () => import('@/views/product/Selection.vue'),
    meta: { title: '产品选定 / 岗位匹配', permission: 'product:selection:update' }
  },
  {
    path: 'blueprint',
    ...maybeRouteName(withNames, 'product-mgmt-blueprint'),
    component: () => import('@/views/product/Blueprint.vue'),
    meta: { title: '建设蓝图', permission: 'product:blueprint:view' }
  },
  {
    path: 'maturity',
    ...maybeRouteName(withNames, 'product-mgmt-maturity'),
    component: () => import('@/views/product/MaturityStats.vue'),
    meta: { title: '成熟度统计', permission: 'product:maturity:view' }
  },
  {
    path: 'usage',
    ...maybeRouteName(withNames, 'product-mgmt-usage'),
    component: () => import('@/views/product/usage/UsageAnalysis.vue'),
    meta: { title: '使用率', permission: 'product:usage_analysis:view' }
  },
  {
    path: 'satisfaction',
    ...maybeRouteName(withNames, 'product-mgmt-satisfaction'),
    component: () => import('@/views/product/satisfaction/SatisfactionAnalysis.vue'),
    meta: { title: '满意度', permission: 'product:satisfaction_analysis:view' }
  }
]

const createProductRoute = (path: string, defaultRouteBasePath: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/product/ProductMgmtLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(productManagementRouteCandidates),
    defaultRouteBasePath,
    defaultRouteCandidates: productManagementRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createProductChildren(withNames)
})

const productRoutes: RouteRecordRaw[] = [
  createProductRoute('t/:tenantCode/products', '/t/:tenantCode/products', true),
  createProductRoute('products', '/products', false),
]

export default productRoutes
